import {
  Box,
  Divider,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import {
  ConsolePreSalesAggregationDetailFragment,
  Maybe,
} from '@/clients/utoniq-core/schema'
import { useRouter, useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

type TicketStatusTableCellProps = {
  preSaleItems: Maybe<ConsolePreSalesAggregationDetailFragment['preSaleItems']>
}

export const TicketStatusTableCell: Organism<TicketStatusTableCellProps> = ({
  preSaleItems,
}) => {
  const { t } = useTranslation('consoleEventDetail')
  const { generatePath, routerPages } = useRouter()
  return (
    <OrganismFrame>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="none" sx={{ border: 'none', width: 100 }}>
                <Typography variant="subtitle1" color="text.hint">
                  {t('ticketName', 'チケット名')}
                </Typography>
              </TableCell>
              <TableCell padding="none" sx={{ border: 'none' }}>
                <Typography
                  variant="subtitle1"
                  color="text.hint"
                  align="center"
                >
                  {t('purchasePerStock', '購入数/\n在庫数')}
                </Typography>
              </TableCell>
              <TableCell padding="none" sx={{ border: 'none', minWidth: 110 }}>
                <Typography
                  variant="subtitle1"
                  color="text.hint"
                  align="center"
                >
                  {t('usedUnusedPerPurchase')}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!preSaleItems && (
              <TableRow>
                <TableCell colSpan={3} sx={{ px: 0, py: 6, border: 'none' }}>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    align="center"
                  >
                    {t('emptyTicketMessage', 'チケット状況はありません')}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {preSaleItems?.map((preSaleItem, index) => (
              <TableRow key={index}>
                <TableCell sx={{ px: 0, py: 3, width: 100 }}>
                  <Link
                    variant="body2"
                    href={`${generatePath(routerPages.ConsoleItemDetail, {
                      itemId: preSaleItem.itemId,
                    })}?ticketOpen=true`}
                  >
                    {preSaleItem?.item.title}
                  </Link>
                </TableCell>
                <TableCell sx={{ px: 0, py: 3 }} align="center">
                  <Box sx={{ width: 'fit-content', margin: '0 auto' }}>
                    <Typography
                      variant="body2"
                      component="span"
                      sx={{
                        fontVariantNumeric: 'stacked-fractions',
                        minWidth: 36,
                      }}
                    >
                      {preSaleItem.ticketUsedCount ||
                      preSaleItem.ticketUnusedCount
                        ? (preSaleItem.ticketUsedCount ?? 0) +
                          (preSaleItem.ticketUnusedCount ?? 0)
                        : '-'}
                    </Typography>
                    <Divider sx={{ borderColor: 'text.primary' }} />
                    <Typography
                      variant="body2"
                      sx={{
                        fontVariantNumeric: 'stacked-fractions',
                        minWidth: 36,
                      }}
                    >
                      {preSaleItem.item.issuedNumber || '-'}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell sx={{ px: 0, py: 3, minWidth: 110 }} align="center">
                  <Box sx={{ width: 'fit-content', margin: '0 auto' }}>
                    <Typography
                      variant="body2"
                      component="span"
                      sx={{
                        fontVariantNumeric: 'stacked-fractions',
                        minWidth: 36,
                      }}
                    >
                      {preSaleItem.ticketUsedCount || '-'}
                      <Typography
                        variant="body2"
                        component="span"
                        color="warning.main"
                        sx={{
                          fontVariantNumeric: 'stacked-fractions',
                          minWidth: 36,
                        }}
                      >
                        ({preSaleItem.ticketUnusedCount || '-'})
                      </Typography>
                    </Typography>
                    <Divider sx={{ borderColor: 'text.primary' }} />
                    <Typography
                      variant="body2"
                      sx={{
                        fontVariantNumeric: 'stacked-fractions',
                        minWidth: 36,
                      }}
                    >
                      {preSaleItem.ticketUsedCount ||
                      preSaleItem.ticketUnusedCount
                        ? (preSaleItem.ticketUsedCount ?? 0) +
                          (preSaleItem.ticketUnusedCount ?? 0)
                        : '-'}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </OrganismFrame>
  )
}
